<template>
  <layout>
    <div class="w-full sm:w-1/2 mx-auto mb-0 mt-4 px-4 py-2 text-left">

      <div class="max-w-lg mb-5 pb-0">
        <p class="text-lg mb-2 sm:text-xl font-extralight flex items-center">
          <Link :href="route('control-panel.workshops.index')"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg></Link>
          {{ headline }} <testmode-badge :session="session" class="ml-3"></testmode-badge>
        </p>

        <progress-tabs :active-index="2" :session="session" :disable-more="false" @clicked="handleTabClick"></progress-tabs>


        <!-- session logo upload: start -->
        <!-- <div v-if="session.session_type == 'diy_workshop'">
          <session-logo-upload 
          :session="session"
          @logoSettingsUpdated="logoSettingsUpdated"
          ></session-logo-upload>
        </div> -->
        <!-- session logo upload: end -->

        <!-- customer: start -->
        <div>
          <label class="block text-sm pl-3 mb-3">Markenname</label>
          <input type="text" v-model="form.brandname" @keyup="onChangeBrandname"
            class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 sm:mr-2 sm:py-2 rounded-md block sm:inline w-full  shadow-none sm:text-sm focus:ring-markencode-blue mb-0"
            placeholder="" />
        </div>
        <!-- customer: end -->


        <!-- show answers: start -->
        <div v-if="session.session_type == 'workshop'" class="flex items-center px-2 h-12">
          <!-- focus:ring-2 focus:ring-markencode-blue focus:ring-offset-2 -->
          <button id="cy_show_answers" type="button" @click="toggleShowAnswersButton"
            class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none ring-0"
            role="switch" aria-checked="false">
            <span class="sr-only">Antworten anzeigen</span>
            <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md"></span>

            <span aria-hidden="true"
              class="pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
              :class="form.showLiveResults ? 'bg-markencode-blue' : 'bg-gray-200'
                "></span>

            <span aria-hidden="true"
              class="pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
              :class="form.showLiveResults ? 'translate-x-5' : 'translate-x-0'"></span>
          </button>

          <span class="ml-3 text-sm" id="annual-billing-label font-medium text-gray-900" v-text="showLiveResultsText">
          </span>
        </div>
        <!-- show answers: end -->

      </div>


      <p class="mt-0 mb-2 ml-1 text-lg sm:text-xl font-extralight">
        Bitte Fragen auswählen
      </p>

      <div class="mb-3 ml-1 max-w-lg">
        <label class="flex items-center cursor-pointer">
          <input
            type="checkbox"
            :checked="areAllPhasesChecked"
            @change="toggleAllPhases($event.target.checked)"
            class="mt-0.5 h-4 w-4 shrink-0 cursor-pointer text-markencode-blue border-gray-300 focus:ring-markencode-blue"
          />
          <span class="ml-3 text-sm">Alle Fragen auswählen / abwählen</span>
        </label>
      </div>


      <fieldset class="mb-6">
        <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-gray-200" -->



        <draggable :list="form.phases" handle=".order-handle" class="space-y-2 flex flex-col max-w-lg"
          ghost-class="ghost" tag="div">
          <!-- phases: start -->
          <div v-for="(phase, idx) in form.phases" :key="idx"
            class="rounded-tl-md rounded-md flex cursor-pointer border focus:outline-none p-2"
            :class="itemClasses(phase)">
            <label :id="`cy_phase_${phase.id}`" class="flex p-1 items-center grow cursor-pointer">
              <input type="checkbox" :checked="phase.checked" @change="togglePhase(phase)"
                class="mt-0.5 h-4 w-4 shrink-0 cursor-pointer text-markencode-blue border-gray-300 focus:ring-markencode-blue" />
              <span class="ml-3 flex flex-col w-full">
                <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->

                <!-- <span v-if="phase.question?.brandname" class="block text-sm" v-html="placeholderWrapper(phase, idx)"></span> -->

                <div v-if="isPlaceholderQuestion(phase)" class="text-sm pr-2">
                  {{ preQuestion(phase) }}
                  <input type="text" v-model="form.phases[idx].question.brandname"
                    class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 rounded-md block sm:inline w-full my-1 shadow-none text-sm text-center focus:ring-markencode-blue">
                  {{ postQuestion(phase) }}
                </div>

                <span v-else class="block text-sm">{{ phase.title }}</span>

                <span v-if="phase.subtitle" class="block text-sm sm:inline">{{
                  phase.subtitle
                }}</span>

                <span
                  v-if="showInternalQuestionMeta && phase.type === 'workshop_question' && phase.question"
                  class="block text-xs text-gray-400 mt-1"
                >
                  Typ: {{ phase.question.full_type || phase.question.question_type || '-' }} | Ergebnisanzeige: {{ phase.question.full_live_results_type || phase.question.live_results_type || '-' }}
                </span>

                <span v-if="['choices', 'radio'].includes(phase?.question?.question_type)"
                  class="block text-xs sm:inline italic text-gray-400">{{ phase?.question?.parameters?.choices?.join(',')
                  }}</span>
              </span>
            </label>

            <div class="w-12 border-l flex items-center shrink-0 justify-center order-handle cursor-move">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-5 h-5 shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
              </svg>
            </div>
          </div>
          <!-- phases: end -->
        </draggable>
      </fieldset>


      <div class="max-w-lg w-full flex items-end justify-end border-t border-gray-300 pt-4">
        <button type="submit" @click="submit"
          class="inline-flex justify-center bg-brandpreneurship-dark-gray w-full sm:w-min rounded-md border border-transparent px-4 py-2 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
          :class="disabled ? 'opacity-50 cursor-default' : 'hover:bg-black focus:outline-none focus:border-black opacity-100 cursor-pointer'">
          WEITER
        </button>
      </div>
    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import draggable from 'vuedraggable';
import SessionLogoUpload from '@/Pages/ControlPanel/Shared/SessionLogoUpload';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import ProgressTabs from '@/Pages/ControlPanel/Workshops/Shared/ProgressTabs';
import TestmodeBadge from '@/Pages/ControlPanel/Shared/TestmodeBadge';

export default {
  components: {
    Layout,
    draggable,
    SessionLogoUpload,
    HorizontalDivider,
    ProgressTabs,
    TestmodeBadge,
  },

  props: ['session', 'translations', 'phases'],

  data() {
    return {
      form: this.$inertia.form({
        // introtext: this.session.introtext || (this.session.brandname ? `zu einer Umfrage über ${this.session.brandname}.` : 'zu einer Umfrage.'),
        brandname: this.session.brandname || '',
        phases: this.phases,
        showLiveResults: this.session.session_type == 'workshop' ? true : false,
        // showQrCode: this.session.session_type == 'diy_workshop' ? this.session.show_qr_code : true,
        // logo_position: this.session.logo_position || 'center',
        // logo_size: this.session.logo_size || 'm',
        // placeholders: {
        //   p1: this.session.brandname,
        // },
      }),
    };
  },

  watch: {
    form: {
      handler: function () {
        // console.log(this.form.brandname);

        // this.form.phases = this.form.phases.map(item => {
        //   if (item.question && 'brandname' in item.question) {
        //     item.question.brandname = this.form.brandname;
        //   }
        //   return item;
        // });

      },
      deep: true,
    },
  },

  methods: {
    onChangeBrandname() {
      console.log(this.form.brandname);

      this.form.phases = this.form.phases.map(item => {
        if (item.question && 'brandname' in item.question) {
          item.question.brandname = this.form.brandname;
        }
        return item;
      });
    },

    togglePhase(selectedPhase) {
      this.form.phases = this.form.phases.map((phase) => {
        if (phase.id == selectedPhase.id) {
          phase.checked = !phase.checked;
        }

        return phase;
      });
    },

    toggleAllPhases(checked) {
      this.form.phases = this.form.phases.map((phase) => {
        phase.checked = checked;
        return phase;
      });
    },

    toggleShowAnswersButton() {
      this.form.showLiveResults = !this.form.showLiveResults;
    },

    toggleShowQrCode() {
      this.form.showQrCode = !this.form.showQrCode;
    },

    placeholderWrapper(phase, idx) {
      return '';
      // return String(phase.title).replaceAll('%BRANDNAME', '<input type="text" v-model="' + this.form.phases[idx]?.question?.brandname + '" class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5  rounded-md block sm:inline w-full w-32 shadow-none text-sm text-center focus:ring-markencode-blue">');
    },

    preQuestion(phase) {
      return String(phase.title).substring(0, String(phase.title).indexOf('%BRANDNAME'));
    },

    postQuestion(phase) {
      return String(phase.title).substring(String(phase.title).indexOf('%BRANDNAME') + 10);
    },


    isPlaceholderQuestion(phase) {
      if (!this.session?.is_placeholder_session) {
        return false;
      }

      if (!phase.question?.is_placeholder_question) {
        return false;
      }

      if (!String(phase.title || '').includes('%BRANDNAME')) {
        return false;
      }

      if (phase.question.is_placeholder_question) {
        return true;
      }

      return false;
    },

    handleTabClick(tab) {
      this.submit(tab);
    },

    submit(tab) {
      this.form.post(
        this.route('control-panel.workshops.questions.store', {
          sessionUuid: this.session.uuid,
          tab: tab,
        }),
        {}
      );
    },

    logoSettingsUpdated(settings) {
      this.form.logo_position = settings?.position || 'center';
      this.form.logo_size = settings?.size || 'm';
    },

    itemClasses(phase) {
      let classes = [];

      if (phase.type != 'workshop_question') {
        classes.push('bg-black text-gray-300');

        if (phase.checked) {
          classes.push('border-white opacity-100');
        } else {
          classes.push('border-black opacity-10');
        }
      } else {
        classes.push('bg-white');

        if (phase.checked) {
          classes.push('border-gray-200 opacity-100');
        } else {
          classes.push('border-gray-200 opacity-50');
        }
      }

      return classes.join(' ');
    },
  },

  computed: {
    areAllPhasesChecked() {
      if (!this.form.phases?.length) {
        return false;
      }

      return this.form.phases.every((phase) => phase.checked);
    },

    showLiveResultsText() {
      if (!this.form.showLiveResults) {
        return 'Antworten nicht anzeigen.';
      }

      return 'Antworten anzeigen.';
    },

    showQrCodeText() {
      if (!this.form.showQrCode) {
        return 'QR-Code und "Bitte teilen"-Hinweis ist nun ausgeblendet.';
      }

      return 'QR-Code und "Bitte teilen"-Hinweis werden jetzt angezeigt.';
    },

    disabled() {
      return false;

      
      if (this.form.brandname.length < 1) {
        return true;
      }

      // const isBrandnameMissing = this.form.phases.some(item => {
      //   return item.question && (!('brandname' in item.question) || item.question.brandname === null || item.question.brandname === '');
      // });

      const isBrandnameMissing = this.form.phases.some(item => {
        return item.question && item.question.is_placeholder_question === true &&
              (!('brandname' in item.question) || item.question.brandname === null || item.question.brandname === '');
      });


      if (isBrandnameMissing) {
        return true;
      }

      let numChecked = this.form.phases.filter((phase) => {
        return phase.checked;
      }).length;

      if (!numChecked) {
        return true;
      }

      return false;
    },

    headline() {
      if (this.session.session_type == 'workshop') {
        return `Workshop ${this.session.project_name || ''}`;
      }

      if (this.session.session_type == 'diy_workshop') {
        return `Umfrage ${this.session.project_name || ''}`;
      }

      return 'Workshops &amp; Umfragen';
    },

    showInternalQuestionMeta() {
      const email = this.$page?.props?.auth?.user?.email;

      if (!email || typeof email !== 'string') {
        return false;
      }

      return email.toLowerCase().endsWith('@brandhelfer.de');
    },
  },
};
</script>
